import type { QuestionnaireFrequency, VerboseQuestionnaireMetadata } from '@gcv/shared';
import { Tooltip } from '@mui/material';

import { lookupQuestionnaireFrequencyLabel } from 'domain/consts/due-diligence';
import type { ListOption, SelectOption } from 'ui';
import { Pill } from 'ui';

export interface QuestionnaireOption extends Omit<SelectOption, 'value'>, ListOption {
  frequency: QuestionnaireFrequency;
}

export const getQuestionnaireOption = (
  questionnaire: VerboseQuestionnaireMetadata,
  manageUpcoming: boolean,
  // only needed in manage upcoming
  alreadyDistributedQuestionnaireIds?: string[]
) => {
  const { frequency } = questionnaire.schedule;

  return {
    value: questionnaire.template_id,
    category: questionnaire.template_category,
    label: questionnaire.name,
    frequency,
    selected: alreadyDistributedQuestionnaireIds?.includes(questionnaire.template_id),
    disabled: manageUpcoming && !questionnaire.distribute,
    sublabel: !questionnaire.distribute ? (
      <Tooltip title="To enable this questionnaire, first turn on its distribution in Settings > Questionnaires">
        <Pill text="Distribution is off" size="small" style="grey" sx={{ mt: '8px' }} />
      </Tooltip>
    ) : (
      `Frequency: ${lookupQuestionnaireFrequencyLabel(frequency)}`
    )
  } as QuestionnaireOption;
};
